import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, Outlet, useParams } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import imageCompression from 'browser-image-compression';
import toast, { Toaster } from 'react-hot-toast';
import TextareaAutosize from 'react-textarea-autosize';
import ReactGA from "react-ga4";

import Offcanvas from 'react-bootstrap/Offcanvas';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';

import ImgNo from './img/NoImg.png';
import ImgBroken from './img/BrokenImg.png';
import { settings } from 'firebase/analytics';





export const Static = {

    SvrAddr: 'https://bg-work.cresoul.workers.dev/',

    AppLink: 'https://belgung.com/game/',

    ImgType: {
        pf: 'pf/',
        lib: 'lib/',
        qz: 'qz/',
    },
};



export function ShowLoading() {

    return (
        <div className='d-flex justify-content-center align-items-center' style={{ width: '100%', height: '100%' }}>
            <Spinner animation="border" />
        </div>
    )
}

function GetTextAvatar(nick, size, styles) {
    let hash = 0;
    const safeNick = typeof nick === 'string' ? nick.trim() : '';

    for (let i = 0; i < safeNick.length; i++) {
        hash = safeNick.charCodeAt(i) + ((hash << 5) - hash);
    }

    const color = Math.floor(Math.abs(Math.sin(hash) * 16777215) % 16777215).toString(16);
    const col = '#' + ('000000' + color).slice(-6);
    const initials = safeNick
        .split(/\s+/)
        .filter(word => word.length > 0)
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .slice(0, 2) || '?';

    return (
        <div style={{ ...styles.initials, backgroundColor: col }}>
            {initials}
        </div>
    );
}

function AvatarImage({ img, nick, size, styles }) {
    const [imageError, imageErrorSet] = useState(false);

    useEffect(() => {
        imageErrorSet(false);
    }, [img]);

    if (imageError) {
        return GetTextAvatar(nick, size, styles);
    }

    return (
        <img
            src={img}
            alt="avatar"
            style={{
                objectFit: 'cover',
                width: size,
                height: size,
                justifyContent: 'center',
                alignItems: 'center',
            }}
            onError={() => imageErrorSet(true)}
        />
    );
}


export function GetAvatar(img, nick = '', size = '30px', loaded = true) {
    let res;

    const styles = {
        container: {
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: '#f0f0f0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
        },
        skeleton: {
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: '#ccc',
        },
        placeholder: {
            width: size,
            height: size,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#d3d3d3',
            borderRadius: '50%',
            borderStyle: 'dashed',
            borderWidth: 2,
            borderColor: '#a9a9a9',
            display: 'flex',
        },
        initials: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: size,
            height: size,
            fontSize: size * 0.4,
            color: '#ffffff',
            borderRadius: '50%',
        },
    };

    if (!loaded) {
        return <div style={styles.skeleton}></div>;
    } else if (img === 'null') {
        res = (
            <div style={styles.placeholder}>
                <i className="fi-rr-user  text-black-50" style={{ fontSize: size * 0.4, }}></i>
            </div>
        );
    } else if (img && typeof img === 'string' && img.trim() !== '') {
        res = <AvatarImage img={img} nick={nick} size={size} styles={styles} />;
    } else {
        res = GetTextAvatar(nick, size, styles);
    }

    return (
        <div style={{ ...styles.container, padding: 2 }}>
            {res}
        </div>
    );
}

export function GetUserBadge(img, user, size, my = false, sex = false, maker = false) {
    let col = 'text-black';

    if (sex) {
        col = user.sex === 'm' ? 'text-info' : 'text-danger';
    }

    const badgeStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderWidth: '1px',
        borderRadius: '10px',
        margin: '2px',
        padding: '8px',
        gap: '5px',
    };

    return (
        <div className='bg-white border border-light' style={badgeStyle}>
            {GetAvatar(img, user.nick, size)}
            <span className={col} style={{ fontWeight: my ? 'bold' : 'normal' }}>{user.nick}</span>
            {maker && <span className='text-primary'>*</span>}
        </div>
    );
}



export const ModalEditPf = ({ show, handleClose, playmod, sexmod, cpmod, cb }) => {

    const store = useSelector((state) => state);

    let [name, nameSet] = useState(localStorage.getItem(playmod ? 'nick' : 'id'));
    let [sex, sexSet] = useState(localStorage.getItem('gender') == null ? 'n' : localStorage.getItem('gender'));

    const taRefNick = useRef();



    function Done() {

        if (name == null || name == '') {
            alert("닉네임을 입력 해 주세요.");
            return;
        }
        if (name.length > 10) {
            alert(playmod ? "이름이 너무 길어요." : "아이디가 너무 길어요.");
            return;
        }

        if (cpmod) {
            if (sex == 'n') {
                alert("성별을 선택 해 주세요.");
                return;
            }
        }

        handleClose();


        axios.post(Static.SvrAddr + 'setprofile', {
            nick: name,
            sex: sex,
            user: localStorage.getItem('uuid'),
        }).then((res) => {
            console.log(res);

            localStorage.setItem('uuid', res.data[0][0].user);
            localStorage.setItem('id', name);
            localStorage.setItem('gender', sex);

            if (localStorage.getItem('nick') == null) {
                localStorage.setItem('nick', name);
            }

            cb(name);

        }).catch(() => {
            console.log('실패함');
        })
    }


    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                centered
            >
                <Modal.Header>
                    <Modal.Title>{playmod ? '이름이 뭐에요?' : '프로필 설정'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className='text-start fs-6 fw-light px-3'>
                        <FloatingLabel
                            controlId="floatingInput"
                            label={playmod ? "닉네임 입력" : '아이디 입력'}
                        >
                            <Form.Control ref={taRefNick} type="text" placeholder="" value={name} onChange={(e) => { nameSet(e.target.value) }} />
                        </FloatingLabel>
                        {playmod ? '친구가 알 수 있는 이름이 좋아요.' : '게임 공유시 모든 유저들에게 보여져요. 중복되는 아이디가 있을경우 이름 뒤에 숫자가 붙어요.'}
                    </div>

                    {sexmod && (
                        <>
                            <div className='d-flex btn-group px-3 pt-4'>
                                <input type="radio" className="btn-check" name="sex" id="null" value="n" onChange={(e) => { sexSet(e.target.value) }} checked={sex === 'n'} />
                                <label className="btn btn-outline-secondary" for="null">비공개</label>
                                <input type="radio" className="btn-check" name="sex" id="male" value="m" onChange={(e) => { sexSet(e.target.value) }} checked={sex === 'm'} />
                                <label className="btn btn-outline-info" for="male"><i class="fi-rr-mars pe-1 va-m"></i>남</label>
                                <input type="radio" className="btn-check" name="sex" id="female" value="f" onChange={(e) => { sexSet(e.target.value) }} checked={sex === 'f'} />
                                <label className="btn btn-outline-danger" for="female"><i class="fi-rr-venus pe-1 va-m"></i>여</label>
                            </div>
                            <div className='text-start fs-6 fw-light px-3'>
                                이성끼리 매칭 결과를 위해 정확한 성별을 선택해 주세요.
                            </div>
                        </>
                    )}



                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => {
                        sexSet(localStorage.getItem('gender') == null ? 'n' : localStorage.getItem('gender'));
                        handleClose();
                    }}>
                        취소
                    </Button>
                    <Button variant="primary" onClick={() => { Done() }}>
                        완료 <i class="fi-rr-check-circle va-m"></i>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}


export const ModalEditImg = ({ show, handleClose, imgSrc, imgNull, cbUpload }) => {

    const store = useSelector((state) => state);

    let [img, imgSet] = useState();

    const imgInputRef = useRef();

    let imgfile = useRef();


    useEffect(() => {

        if (!show) {
            return;
        }

        imgSet(imgSrc);


        if (imgSrc == null) {
            imgSet(imgNull);
            imgInputRef.current.click();
        }

    }, [show])

    async function onChangeImg(e) {

        imgfile.current = await ImgResize(e.target.files[0], 800);

        e.target.value = '';

        imgSet(URL.createObjectURL(imgfile.current));
    };


    function Remove(key) {

        imgSet(imgNull);

        imgfile.current = imgNull;
    }


    function Done() {

        handleClose();

        cbUpload(imgfile.current);

        imgfile.current = null;
    }


    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                centered
            >
                <Modal.Body>

                    <div className='d-flex flex-column gap-2'>
                        <input
                            type="file"
                            accept="image/*"
                            ref={e => imgInputRef.current = e}
                            style={{ display: 'none', width: '100%' }}
                            onChange={(e) => { onChangeImg(e) }}
                        />
                        <img
                            src={img}
                            style={{
                                objectFit: 'contain',
                                height: '420px',
                            }}
                            onError={(e) => { e.target.src = ImgBroken }}
                            onClick={() => {
                                imgInputRef.current.click();
                            }}
                        />
                    </div>

                </Modal.Body>
                <Modal.Footer className='d-flex'>
                    <button type="button" class="btn btn-outline-danger" onClick={() => { Remove() }}>
                        <i class="fi-rr-trash va-m"></i>
                    </button>
                    <button type="button" class="ms-auto btn btn-outline-secondary" onClick={() => {
                        imgfile.current = null;
                        handleClose()
                    }}>
                        취소
                    </button>
                    <Button variant="primary" onClick={() => { Done() }}>
                        완료 <i class="fi-rr-check-circle va-m"></i>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}




export async function ImgResize(img, size) {

    console.log('originalFile instanceof Blob', img instanceof Blob); // true
    console.log(`originalFile size ${img.size / 1024 / 1024} MB`);

    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: size,
        useWebWorker: true,
    }
    try {
        const imgComp = await imageCompression(img, options);
        console.log('compressedFile instanceof Blob', imgComp instanceof Blob); // true
        console.log(`compressedFile size ${imgComp.size / 1024 / 1024} MB`); // smaller than maxSizeMB

        return imgComp;
    } catch (error) {
        console.log(error);
    }

}

export async function ImgUpload(svr, img, key) {

    await axios.post(svr + 'puts3url', {
        method: 'put',
        key: key
    }).then(res => {

        axios.put(res.data.url, img, {
            headers: { 'Content-Type': img.type }
        }).then(res2 => {
            console.log('IMG UPLOAD OK');

            return res2;

        }).catch(error => {
            console.error(error);
            return error;
        });

    }).catch(error => {
        console.error(error);
    });

};



export async function ImgGet(svr, key) {

    try {
        const load = await axios.post(svr + 'gets3url', {
            method: 'get',
            key: key
        }).then(res => {
            console.log('ImgGet= ' + res.data.url);
            return res.data.url;

        }).catch(error => {
            console.log(error);
            return null;
        });

        return load;
    }
    catch (err) {
        console.error(err);
    }
}

export async function ImgGetHas(svr, key) {

    try {
        const load = await axios.post(svr + 'hasgets3url', {
            method: 'get',
            key: key
        }).then(res => {
            return res.data;

        }).catch(error => {
            console.log(error);
            return null;
        });

        return load;
    }
    catch (err) {
        console.error(err);
    }
}


export function GetPFImgClass(sex) {

    if (sex == 'm') return 'rounded-circle mx-1 border border-2 border-info';
    if (sex == 'f') return 'rounded-circle mx-1 border border-2 border-danger';
    return 'rounded-circle mx-1';
}


export function SaveToast(msg) {
    sessionStorage.setItem('toast', msg);
}

export function ShowToast() {
    let tm = sessionStorage.getItem('toast');
    if (tm != null) {
        setTimeout(() => {
            toast.success(tm);
        }, 500);

        sessionStorage.removeItem('toast');
    }
}


export const ModalCopyGame = ({ show, handleClose, game, maker, user, qz }) => {

    const store = useSelector((state) => state);
    const navigate = useNavigate();

    let [title, copyTitleSet] = useState(game.title);
    let [desc, copyDescSet] = useState(game.sub);
    const taRefTitle = useRef();
    const taRefDesc = useRef();

    function CopyGame() {

        if (title == null) {
            alert("제목을 입력 해 주세요.");
            taRefTitle.current.focus();
        }
        else if (title.length < 2) {
            alert("제목을 2 글자 이상 입력 해 주세요.");
            taRefTitle.current.focus();
        }
        else if (title.length > 50) {
            alert("제목이 너무 길어요.");
            taRefTitle.current.focus();
        }
        else {
            handleClose();

            axios.post(Static.SvrAddr + 'copygame', {
                game: game.uid,
                title: title,
                sub: desc,
                maker: maker,
                user: user
            }).then((res) => {

                let newUid = res.data[0][0].game;

                qz.map((d, i) => {
                    if (d[3] == '@') CopyImg('bg-qz/qz/' + game.uid + '_' + i + '-A', 'qz/' + newUid + '_' + i + '-A');
                    if (d[4] == '@') CopyImg('bg-qz/qz/' + game.uid + '_' + i + '-B', 'qz/' + newUid + '_' + i + '-B');
                })


                navigate('/game/' + newUid);
                window.location.reload();

                SaveToast('새 게임이 만들어졌어요.');

                ReactGA.event('copy_game');

            }).catch(() => {
                console.log('실패함');
            })
        }
    }

    function CopyImg(from, to) {
        console.log(from + ' / ' + to);
        axios.post(Static.SvrAddr + 'copys3', {
            from: from,
            to: to,
        }).then((res) => {
            console.log(res);
        }).catch(() => {
            console.log('실패함');
        })
    }


    return (

        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            centered
        >
            <Modal.Header>
                <Modal.Title>이 게임 복사하기</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='text-start fs-6 fw-light px-3'>
                    같은 문제로 새 게임을 만들어요. 내 답안도 그대로 적용되니 게임을 또 하지 않아도 되요.
                </div>

                <div className='px-4 my-3'>
                    <div className='text-start fs-6'>
                        제목
                    </div>
                    <TextareaAutosize id='#title' className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2 '
                        placeholder="제목 입력" value={title} style={{ width: '100%' }} ref={taRefTitle}
                        onChange={(e) => {
                            copyTitleSet(e.target.value)
                        }} />
                </div>

                <div className='px-4 my-3'>
                    <div className='text-start fs-6'>
                        설명 (선택)
                    </div>
                    <TextareaAutosize className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2 '
                        placeholder="설명 입력" value={desc} style={{ width: '100%' }} ref={taRefDesc}
                        onChange={(e) => {
                            copyDescSet(e.target.value)
                        }} />
                </div>


            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => { handleClose() }}>
                    취소
                </Button>
                <Button variant="primary" onClick={() => { CopyGame() }}>
                    <i class="fi-rr-check-circle va-m"></i> 만들기
                </Button>
            </Modal.Footer>
        </Modal>

    )

}



export const ModalMsgInput = ({ show, handleClose, gid, idx, user }) => {

    const store = useSelector((state) => state);

    let [msg, msgSet] = useState('');

    let [sendable, sendableSet] = useState(false);

    const taRefMsg = useRef();

    const msgLengthMax = 300;


    useEffect(() => {

        if (!show) {
            return;
        }

        msgSet('');

        setTimeout(() => {
            taRefMsg.current.focus();
        }, 100);

        console.log(idx);

    }, [show])

    useEffect(() => {

        if (msg == '') {
            sendableSet(false);
        }
        else if (msg.length > msgLengthMax) {
            sendableSet(false);
        }
        else {
            sendableSet(true);
        }

    }, [msg])


    function SendMsg() {
        handleClose();

        axios.post(Static.SvrAddr + 'addmsg', {
            Game_uid: gid,
            idx: idx,
            msg: msg,
            user: user
        }).then((res) => {
            window.location.reload();

            ReactGA.event('write_reply');

        }).catch(() => {
            console.log('실패함');
        })
    }

    return (

        <Offcanvas show={show} onHide={handleClose} placement='bottom' style={{ height: '200px' }}>
            <Offcanvas.Body >
                <TextareaAutosize className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2' minRows={4} maxRows={4}
                    placeholder="댓글 입력" value={msg} style={{ width: '100%' }} ref={taRefMsg}
                    onChange={(e) => { msgSet(e.target.value) }} />

                <div className='d-flex justify-content-end align-items-center'>
                    <span className={sendable ? ('') : ('text-danger')}>
                        {msg.length}
                    </span>
                    /{msgLengthMax}
                    <Button className='ms-3' variant="primary" disabled={!sendable} onClick={() => { SendMsg() }}>
                        완료 <i class="fi-rr-check-circle va-m"></i>
                    </Button>
                </div>
            </Offcanvas.Body>
        </Offcanvas>

    )

}
